<div class="side-sheet side-sheet-details" [ngClass]="{'active': recordId}">
  <div class="d-flex h-100">

    <div class="overlay" (click)="close.emit()"></div>

    <div class="sheet-container">
      <div class="sheet-head d-block p-0">
        <div class="head">
          <div class="title">
            {{'rights.actionLog' | translate}}
          </div>
          <a (click)="close.emit()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path id="ic_close"
                d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                transform="translate(-204.746 755.5)" fill="#8e8fa2" />
            </svg>
          </a>
        </div>
      </div>

      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>

      <div *ngIf="!dataLoading">
        <div class="sheet-content">
          <ul class="list_timeLine" *ngIf="recordsData.length; else dataEmpty">
            <li class="item_timeLine" *ngFor="let record of recordsData">
              <div class="date_log">
                {{record.date| date:'d MMM, y'}}
              </div>
              <div class="item_content">
                <div class="state_log">
                  <span></span>
                </div>
                <div class="item_inner">
                  <div class="time_log">
                    {{record.date| date:'h:mm a'}}
                  </div>
                  <p>
                    {{record.title}}
                  </p>
                  <div class="item_author">
                    <img *ngIf="record.createdByImage" [src]="record.createdByImage"
                      (error)='record.createdByImage = ""'>
                    <span *ngIf="!record.createdByImage">
                      {{ record.createdBy| shortName }}
                    </span>
                    <div class="item_avatar_content">
                      <!-- <span>
                        {{record.createdBy}}
                      </span> -->
                      <h4>
                        {{record.createdBy}}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ng-template #dataEmpty>
            <empty-state [img]='"./assets/images/illu_empty_state.png"' [title]='"group.NoDataFound"|translate'>
            </empty-state>
          </ng-template>
        </div>

      </div>
    </div>
  </div>
</div>